/**
 * `FontLoader` is retained for API stability but is now a NO-OP.
 *
 * The three Sill font families are self-hosted (woff2 under `./fonts/`) and
 * loaded via the side-effect CSS import `@sill/ui/css/fonts` (see
 * `src/css/fonts.css`). Previously this component injected a Google Fonts
 * `<link>` at runtime; that external dependency was removed so a visitor's
 * browser never contacts fonts.googleapis.com / fonts.gstatic.com — no IP
 * leaks to Google (subprocessor-cleanup follow-up).
 *
 * Kept as a no-op (no props, returns `null`) so existing `<FontLoader />`
 * call sites in the apps don't need to change.
 */
export function FontLoader() {
    return null;
}
//# sourceMappingURL=FontLoader.js.map